import { LoanCrud } from "./loanCrud";

export default function NotAssignLoan(){
    return <LoanCrud name="待添加按揭" type="notAssign" router="notAssignLoans" />
}